// extracted by mini-css-extract-plugin
export var parcelRow = "_vg-0";